import { supabase } from '@/integrations/supabase/client';

/** Returns the authenticated user's ID. Throws if not authenticated. */
export async function requireAuthUser(): Promise<string> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('User not authenticated');
  return user.id;
}
